// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__wM_AH","greenBox":"styles_greenBox__SAMr_","blueBox":"styles_blueBox__I_tQH","lightBlueBox":"styles_lightBlueBox__3Qr0n"};